import { render, staticRenderFns } from "./ModalSeleccionarPerfil.vue?vue&type=template&id=8d91e8fe&scoped=true&"
import script from "./ModalSeleccionarPerfil.vue?vue&type=script&lang=js&"
export * from "./ModalSeleccionarPerfil.vue?vue&type=script&lang=js&"
import style0 from "./ModalSeleccionarPerfil.vue?vue&type=style&index=0&id=8d91e8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d91e8fe",
  null
  
)

export default component.exports